import { render, staticRenderFns } from "./156-tag-cloud.vue?vue&type=template&id=821dca9a&scoped=true&"
import script from "./156-tag-cloud.vue?vue&type=script&lang=js&"
export * from "./156-tag-cloud.vue?vue&type=script&lang=js&"
import style0 from "./156-tag-cloud.vue?vue&type=style&index=0&id=821dca9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821dca9a",
  null
  
)

export default component.exports